module.exports = __webpack_public_path__ + "static/img/yuntai.72289391.png";